import { useAuth } from '@/services/auth';
import { useCurrentWorkspace } from '@/context/current-workspace';
import { useMasqLink } from '@/utils/navigation';
import { Link } from '@customerio/pluma-components/react';
import { AuditLogsPageContainer } from './components/audit-logs-page-container';

export const AccountAuditLogs = () => {
  const auth = useAuth();
  const currentAccountId = auth.account.id;
  const currentWorkspace = useCurrentWorkspace();
  const workspaceId = currentWorkspace?.id;
  const masqLink = useMasqLink();

  return (
    <AuditLogsPageContainer
      context="account"
      contextId={currentAccountId}
      workspaceId={workspaceId ?? null}
      breadcrumbs={[{ text: 'Settings', href: masqLink('/settings') }, { text: 'Audit logs' }]}
      pageTitle="Account Audit Logs"
      pageDescription={
        <>
          View audit logs to track account-level changes. Looking for workspace-level changes like campaigns or
          segments?{' '}
          {workspaceId != null && workspaceId > 0 ? (
            <Link href={`/workspaces/${workspaceId}/settings/audit-logs`}>View Workspace Audit Logs</Link>
          ) : (
            'View Workspace Audit Logs in your workspace settings.'
          )}
        </>
      }
      backUrlBase={masqLink('/settings/audit-logs')}
      feedbackFeature="Account Audit Logs"
    />
  );
};
